/*
 * Mirrors CollingsDenture-Backend/src/utils/slug.js. Vendor cards link to
 * /vendor/${slugify(name)} and the backend resolves that value, so the two
 * implementations must produce identical output. Change one, change both.
 */
export const slugify = (name) =>
  String(name == null ? "" : name)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
